'use client'

import React, { useEffect, useState } from 'react'

import usePolicyDocumentApi from '@/api/usePolicyDocumentApi'
import { brand } from '@/utils/brand'

import { shipplayContent } from './shipplay.page.content'

const ShipplayTermsPage: React.FC = () => {
  const { title } = shipplayContent
  const [content, setContent] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<string>('')
  const { fetchPolicyDocument } = usePolicyDocumentApi()

  useEffect(() => {
    const loadPolicyDocument = async (): Promise<void> => {
      try {
        setLoading(true)
        const response = await fetchPolicyDocument(brand.key, 'Terms')
        setContent(response.data.content)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load terms of use')
      } finally {
        setLoading(false)
      }
    }

    loadPolicyDocument()
  }, [fetchPolicyDocument])

  return (
    <>
      <div className="snplay-bounds snplay:my-24 snplay:max-w-6xl">
        <h1 className="snplay:mb-8 snplay:text-4xl snplay:font-bold">{title}</h1>
        {loading && <div className="snplay:py-12">Loading terms of use...</div>}
        {error && !loading && (
          <div className="snplay:py-12 snplay:text-red-600">Error: {error}</div>
        )}
        {!loading && !error && (
          <div className="policy-content" dangerouslySetInnerHTML={{ __html: content }} />
        )}
      </div>
    </>
  )
}

export default ShipplayTermsPage
